import { derived, writable } from "svelte/store";
export const fixedNews = writable([]);
export const selectedGroup = writable(null);
export const viewAllVideosData = writable(null);
export const scrolledPublicationId = writable('');
export const isHaveFixedNews = derived(fixedNews, $fixedNews => !!$fixedNews.length);
